import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";
import { INVESTMENT_STATUSES } from "../constants";
import { useMemo } from "react";

function Status({ data }) {
  const statuses = Object.values(INVESTMENT_STATUSES)
  const currentStatus = statuses.find((s) => s.id === data.stateFirstId)

  const isShowProgress = useMemo(() => {
    const loadingStatuses = [INVESTMENT_STATUSES.waiting.id, INVESTMENT_STATUSES.working.id]

    return loadingStatuses.includes(data.stateFirstId)
  }, [data])
  
  return (
    <Tooltip title={data?.stateFirstTooltip} placement="top">
      <Box display="flex" alignItems="center" justifyContent="center">
        {isShowProgress && (
          <CircularProgress size="20px" color={currentStatus.color} />
        )}

        <Typography
          variant="h6"
          color={`${currentStatus.color}.main`}
          pl={1}
        >
          {data.stateFirst}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default Status;
